import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import moment from "moment";
import CardsSettlemets from "./CardsSettlemets";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import AddButton from "../common/AddButton";
import SettlementCtoModal from "../settlement-cto/SettlementCtoModal";
import LSGBcards from "./LSGBcards";
import { fetchSettlementData } from "../../../redux/reducers/apiSlice";
import { CopyIcon } from "../../../exports/Images";
import {
  setSelectedTab,
  setSelectedTabDates,
} from "../../../redux/reducers/tabsSlice";
import { selectAuth } from "../../auth/auth.selector";
import { setClickedRowValue } from "../../../redux/reducers/settlementFormSlice";

function Settlemet() {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const navigate = useNavigate();

  const [allSettlementData, setAllSettlementData] = useState([]);
  const { settlementData, loading, error } = useSelector((state) => state.api);
  const selectedGym = useSelector((state) => state?.filters?.selectedGym);
  const selectedYear = useSelector((state) => state?.filters?.selectedYear);
  const selectedMonth = useSelector((state) => state?.filters?.selectedMonth);
  // const startAndEndDate = useSelector((state) => state?.filters?.startAndEndDate);
  // const selectedTab = useSelector((state) => state.tabs.selectedTab);

  // const startDate = new Date(startAndEndDate.startDate);
  // const startYear = startDate.getFullYear();
  // const endDate = new Date(startAndEndDate.endDate);
  // const endMonth = endDate.getMonth() + 1;

  const page = 1;
  const selectedGymQueryParam = selectedGym
    ? `&gym_id=${selectedGym?.value}`
    : "";
  const startDateQueryParam = selectedYear
    ? `&year=${selectedYear?.value}`
    : "";
  const endDateQueryParam = selectedMonth
    ? `&month=${selectedMonth?.value}`
    : "";
  //   const startDateQueryParam = startAndEndDate.startDate ? `&year=${startYear}` : '';
  //   const endDateQueryParam = startAndEndDate.endDate ? `&month=${endMonth}` : '';
  const queryParameters = `page=${page}${selectedGymQueryParam}${startDateQueryParam}${endDateQueryParam}`;

  const [createNewSettlementModal, setCreateNewSettlementModal] =
    useState(false);

  const handleColumnClick = (value) => {
    dispatch(setClickedRowValue(value?.json_details));
    navigate("/settlement-system");
    dispatch(setSelectedTab("settlement-systems"));
    dispatch(
      setSelectedTabDates({
        settlementFrom: value.date_from
          ? moment(value.date_from).tz("Asia/Kolkata").format("DD MMMM YYYY")
          : "---",
        settlementTo: value.date_to
          ? moment(value.date_to).tz("Asia/Kolkata").format("DD MMMM YYYY")
          : "---",
      })
    );
  };

  useEffect(() => {
    dispatch(
      fetchSettlementData({ queryParameters, token: decryptedText?.token })
    );
  }, [queryParameters]);

  useEffect(() => {
    if (settlementData?.status && settlementData?.data) {
      setAllSettlementData(settlementData.data);
    }
  }, [settlementData]);

  const allSettlementTableColumns = [
    {
      dataField: "uid",
      text: "Invoice Id",
    },
    {
      dataField: "gym_name",
      text: "Gym name",
      formatter: (cell, row) => (
        <span className="tdBolder">{row.gym_name ? row.gym_name : "---"}</span>
      ),
    },
    {
      dataField: "date_from",
      text: "Settlement Period",
      formatter: (cell, row) => (
        <div className="breakdownTableData">
          <span className="tdData">
            (
            {row.date_from
              ? moment(row.date_from).tz("Asia/Kolkata").format("DD MMMM YYYY")
              : "---"}
            ) to (
            {row.date_to ? moment(row.date_to).tz("Asia/Kolkata").format("DD MMMM YYYY") : "---"})
          </span>
        </div>
      ),
    },
    {
      dataField: "net_revenue",
      text: "Net Revenue",
      formatter: (cell, row) => (
        <span className="tdBolder">
          ₹{row.net_revenue ? row.net_revenue : "---"}
        </span>
      ),
    },
    {
      dataField: "wtf_share",
      text: "WTF Share",
      formatter: (cell, row) => (
        <span className="tdBolder valueAdderTableData">
          ₹{row.wtf_share ? row.wtf_share : "---"}
        </span>
      ),
    },
    {
      dataField: "gym_share",
      text: "Gym share",
      formatter: (cell, row) => (
        <span className="valueAdderTableData">
          ₹{row.gym_share ? row.gym_share : "---"}
        </span>
      ),
    },
    {
      dataField: "net_cash_flow_gym",
      text: "Net cashflow(Gym)",
      formatter: (cell, row) => (
        <span className="valueAdderTableData">
          ₹{row.net_cash_flow_gym ? row.net_cash_flow_gym : "---"}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Created on",
      formatter: (cell, row) => (
        <div className="breakdownTableData">
          <span className="tdData">
            (
            {row.date_added
              ? moment(row.date_added).tz("Asia/Kolkata").format("DD MMMM YYYY hh:mm A")
              : "---"}
            )
          </span>
        </div>
      ),
    },
    {
      dataField: "created_by_name",
      text: "Created by",
      formatter: (cell, row) => (
        <span className="tdData">{row.created_by_name || "---"}</span>
      ),
    },
    {
      dataField: "settlement_status",
      text: "Payout status",
      formatter: (cell, row) => (
        <span
          className="tdBolder borderRadius"
          style={{
            backgroundColor:
              row.settlement_status !== "pending" ? "#E7F0E9" : "#fef4eb",
            color: row.settlement_status !== "pending" ? "#3A974C" : "#F29339",
          }}
        >
          {row.settlement_status || "----"}
        </span>
      ),
    },
    {
      dataField: "base_price",
      text: "Approval status",
      formatter: (cell, row) => (
        <span
          className="tdBolder borderRadius"
          style={{
            backgroundColor: row.is_approved === 1 ? "#E7F0E9" : "#fef4eb",
            color: row.sis_approved === 1 ? "#3A974C" : "#F29339",
          }}
        >
          {(row.is_approved === 1 ? "Approved" : "Pending") || "----"}
        </span>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="containsIcon" onClick={() => handleColumnClick(row)}>
          <img src={CopyIcon} alt="Copy" />
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <Container fluid className="container">
      <Modal
        isOpen={createNewSettlementModal}
        onRequestClose={() => setCreateNewSettlementModal(false)}
        contentLabel="Settlement Modal"
        ariaHideApp={false}
      >
        <SettlementCtoModal
          onClose={() => setCreateNewSettlementModal(false)}
        />
      </Modal>

      <Row>
        <Col>
          <div className="createNewSettlementBtn">
            <AddButton
              buttonText="+ Create New Settlement"
              onClickButton={() => setCreateNewSettlementModal(true)}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <CardsSettlemets />
        </Col>
      </Row>

      <Row>
        <Col>
          <LSGBcards allSettlementData={allSettlementData} />
        </Col>
      </Row>

      <Row>
        <Col>
          <PayoutsTable
            columnsValues={allSettlementTableColumns}
            dataValues={allSettlementData}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Settlemet;
